import FrontOfficeLabel from './FrontOfficeLabel';
export default{
	FrontOfficeLabel
}
